import { Component, OnInit, PLATFORM_ID, inject } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { JovisTitleService } from "./core/services/jovis-title.service";
import { CookieToolComponent } from "./components/cookie-tool/cookie-tool.component";
import { FooterComponent } from "./components/footer/footer.component";
import { NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { NavbarComponent } from "./components/navbar/navbar.component";
import { ScreenSizeService } from "./shared/screen-size.service";
import { ExportRoutesService } from "./services/export-routes.service";
import { filter } from "rxjs/operators";
import { analyticsPagePath } from "./core/helpers/analytics-page-path";

declare global {
  interface Window {
    dataLayer: any[];
  }
}

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: true,
  imports: [
    NavbarComponent,
    RouterOutlet,
    FooterComponent,
    CookieToolComponent,
  ],
})
export class AppComponent implements OnInit {
  private jovisTitle = inject(JovisTitleService);
  private router = inject(Router);
  private platformId = inject(PLATFORM_ID);
  screenSizeService = inject(ScreenSizeService);
  private exportRoutesService = inject(ExportRoutesService);

  title = "jovis";

  constructor() {
    this.title = this.jovisTitle.setTitle();
  }

  async ngOnInit(): Promise<void> {
    // this.exportRoutesService.exportRoutes();

    if (isPlatformBrowser(this.platformId)) {
      this.router.events
        .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
        .subscribe((e) => {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "page_view",
            page_path: analyticsPagePath(e.urlAfterRedirects),
          });
        });
    }
  }
}
